import { useStore } from 'vuex'

export default defineNuxtRouteMiddleware(() => {
  const store = useStore()
  if (store.state.cart.countCached) {
    return
  }
  store.dispatch('cart/getCartCount')
})
